import { Modal } from '@/components/ui/Modal'

const SHORTCUTS = [
  {
    group: 'Global',
    items: [
      { keys: ['⌘', 'K'],       description: 'Search everything' },
      { keys: ['⌘', '/'],       description: 'Keyboard shortcuts' },
      { keys: ['⌘', 'Z'],       description: 'Undo' },
      { keys: ['⌘', '⇧', 'Z'], description: 'Redo' },
      { keys: ['Esc'],           description: 'Close / deselect' },
    ],
  },
  {
    group: 'Tasks',
    items: [
      { keys: ['⌘', '⇧', 'N'], description: 'New task' },
      { keys: ['⌘', '⇧', 'D'], description: 'Toggle complete' },
      { keys: ['⌘', '⇧', 'C'], description: 'Copy task to project' },
      { keys: ['⌫'],            description: 'Delete selected task' },
    ],
  },
  {
    group: 'Views',
    items: [
      { keys: ['1'],             description: 'List view' },
      { keys: ['2'],             description: 'Board view' },
      { keys: ['3'],             description: 'Timeline view' },
      { keys: ['4'],             description: 'Calendar view' },
      { keys: ['5'],             description: 'Dashboard view' },
    ],
  },
  {
    group: 'Selection',
    items: [
      { keys: ['Click'],         description: 'Open task detail' },
      { keys: ['⇧', 'Click'],   description: 'Bulk select' },
      { keys: ['⌘', 'A'],       description: 'Select all in section' },
    ],
  },
]

export function ShortcutsPanel({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" size="md">
      <div className="grid grid-cols-2 gap-x-10 gap-y-6">
        {SHORTCUTS.map(({ group, items }) => (
          <div key={group}>
            <p className="text-[10px] font-semibold uppercase tracking-wider text-text-faint mb-2.5">{group}</p>
            <div className="space-y-2">
              {items.map(({ keys, description }) => (
                <div key={description} className="flex items-center justify-between gap-4">
                  <span className="text-sm text-text-muted">{description}</span>
                  <div className="flex items-center gap-1 flex-shrink-0">
                    {keys.map((k, i) => (
                      <kbd
                        key={i}
                        className="inline-flex items-center justify-center px-1.5 min-w-[22px] h-[22px] text-[11px] font-medium rounded-md bg-surface-raised border border-border text-text-muted"
                      >
                        {k}
                      </kbd>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  )
}
